module.exports = {"pubnub_prefix":"pubnub","default_instance_name":"default"}


//////////////////
// WEBPACK FOOTER
// ./config.common.json
// module id = 3
// module chunks = 0